import classNames from 'classnames';

import { ArtifactType } from '@/shared/types';
import { ConditionView } from '@/shared/ui';

import { formatDate } from '@/helpers/dates';

import { ChannelTag } from '../../ChannelTag/ChannelTag';
import { Status } from '../../Status/Status';
import { Typography } from '../../Typography';
import { BaseCard } from '../model/BaseCard/BaseCard';
import { ExtractCardProps } from '../model/types';

import { DownloadExtractButton } from './ActionButtons/DownloadExtractButton';
import { DownloadSignFileButton } from './ActionButtons/DownloadSignFileButton';
import { Row, RowRenderer } from './RowRenderer';

export const ExtractCard: React.FC<ExtractCardProps> = ({
  data: { id, title, extractDate, extractPurpose, requestDate, requestNumber, artifacts },
  status,
  channel,
  channels,
  onDownloadExtract,
  onDownloadSignatureFile,
  informerData,
  variant,
}) => {
  const rows: Row[] = [
    {
      label: 'Номер запиту',
      value: requestNumber,
      dataTestId: 'extract-card-number',
    },
    {
      label: 'Дата запиту',
      value: formatDate(requestDate),
      dataTestId: 'extract-card-date',
    },
    {
      label: 'Дата витягу',
      value: formatDate(extractDate),
      dataTestId: 'extract-card-extract-date',
    },
  ];

  const purposeRow: Row[] = [
    {
      label: 'Мета запиту',
      value: extractPurpose,
      dataTestId: 'extract-card-extract-purpose',
      isColFull: true,
      isValueTruncatable: false,
    },
  ];
  return (
    <BaseCard
      data-testid="extract-card"
      className={classNames('service-row-card', `service-row-card--${variant}`)}
      header={
        <div className="service-row-card__header">
          <div className="service-row-card__header-inner">
            <div data-testid="extract-card-status" className="service-row-card__status-wrapper">
              <Status status={status} />
            </div>
            <div data-testid="extract-card-channel-tag" className="service-row-card__channel-tag-wrapper">
              <ChannelTag channel={channels[channel] || channel} />
            </div>
          </div>
          <div className="service-row-card__title-wrapper">
            <Typography data-testid="extract-card-title" variant="H4">
              {title}
            </Typography>
          </div>
        </div>
      }
      body={
        <div className="service-row-card__body">
          <div className="service-row-card__meta-wrapper">
            <RowRenderer rows={purposeRow} />
          </div>
          <div className="service-row-card__meta-wrapper">
            <RowRenderer rows={rows} />
          </div>
        </div>
      }
      informer={informerData}
      actions={[
        <ConditionView
          key="download-signature-file"
          if={
            !!onDownloadSignatureFile && !!artifacts && !!artifacts.find((artifact) => artifact === ArtifactType.SIGN)
          }
        >
          <DownloadSignFileButton
            onClick={(): void =>
              onDownloadSignatureFile && onDownloadSignatureFile({ id, artifactType: ArtifactType.SIGN })
            }
          />
        </ConditionView>,
        <ConditionView
          key="download-extract"
          if={!!onDownloadExtract && !!artifacts && !!artifacts.find((artifact) => artifact === ArtifactType.EXTRACT)}
        >
          <DownloadExtractButton
            onClick={(): void => onDownloadExtract && onDownloadExtract({ id, artifactType: ArtifactType.EXTRACT })}
          />
        </ConditionView>,
      ]}
    />
  );
};
